module.exports = __webpack_public_path__ + "img/hr-tree-04-b-trunk.731c6101.png";